import React from "react";
import Tag from "./Tag"; // Import the Tag component

// Function to map the tag text to a color
const getTagColor = (text) => {
  switch (text) {
    case "Commercial Airplanes":
    case "Defense":
    case "Nudge":  
    case "in-progress": 
      return "blue";
    case "New Growth Area":
    case "Higher Spending":  
    case "increased":
    case "Mission Critical Priority":
    case "Strategic Market Expansion":    
      return "green";
    case "Pain point":
    case "Active Challenge":
      return "red";  
    case "Mission Critical Priority":
      return "yellow";
    default:
      return "gray"; // fallback color for any other text
  }
};

const TagList = ({ tags }) => {
  // If tags is a single string, convert it to an array with one element
  const tagsArray = Array.isArray(tags) ? tags : [tags];

  return (
    <div className="opp-tags">
      {tagsArray.map((tag, index) => (
        <Tag key={index} text={tag} color={getTagColor(tag)} />
      ))}
    </div>
  );
};

export default TagList;
